import { NavLink } from 'react-router';
import { useUnreadNotifications } from '../hooks/queries';
import { useT } from '../i18n';

const items = [
  { to: '/', label: 'Home', icon: HomeIcon },
  { to: '/map', label: 'Map', icon: MapIcon },
  { to: '/run', label: 'Run', icon: RunIcon, primary: true },
  { to: '/leaderboard', label: 'Ranks', icon: TrophyIcon },
  { to: '/profile', label: 'Profile', icon: UserIcon },
];

export function BottomNav() {
  const t = useT();
  return (
    <nav
      className="fixed inset-x-0 bottom-0 z-30 border-t border-ink-700/80 bg-ink-900/95 backdrop-blur pb-safe"
      aria-label="Main"
    >
      <div className="mx-auto grid h-[var(--nav-h)] max-w-lg grid-cols-5">
        {items.map(({ to, label, icon: Icon, primary }) => (
          <NavLink
            key={to}
            to={to}
            end={to === '/'}
            data-testid={`nav-${label.toLowerCase()}`}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center gap-0.5 text-[11px] font-semibold uppercase tracking-wider ${
                isActive ? 'text-volt' : 'text-ink-400'
              }`
            }
          >
            {primary ? (
              <span className="hex-clip -mt-6 grid size-14 place-items-center bg-volt text-ink-950 shadow-lg">
                <Icon />
              </span>
            ) : (
              <span className="relative">
                <Icon />
                {to === '/' ? <UnreadDot /> : null}
              </span>
            )}
            <span>{t(label)}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}

/** New notifications are waiting behind the bell on Home. */
function UnreadDot() {
  const unread = useUnreadNotifications().data?.unread ?? 0;
  if (!unread) return null;
  return <span className="absolute -right-1 -top-0.5 size-2.5 rounded-full bg-enemy ring-2 ring-ink-900" data-testid="nav-unread" />;
}

function HomeIcon() {
  return (
    <svg className="size-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
      <path d="M3 11 12 4l9 7v9a1 1 0 0 1-1 1h-5v-6H9v6H4a1 1 0 0 1-1-1z" strokeLinejoin="round" />
    </svg>
  );
}
function MapIcon() {
  return (
    <svg className="size-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
      <path d="M12 2.5 20 7v10l-8 4.5L4 17V7z" strokeLinejoin="round" />
      <path d="M12 2.5V12m0 0 8-5m-8 5-8-5m8 5v9.5" strokeLinejoin="round" opacity=".55" />
    </svg>
  );
}
function RunIcon() {
  return (
    <svg className="size-7" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <circle cx="14.5" cy="4" r="2.2" />
      <path d="M10.6 7.2 7 8.8 5.6 12.4l1.8.7 1.1-2.7 1.6-.7-1.8 8.2-3.4 2.4 1.1 1.6 4-2.8 1.2-3.4 2.2 2V23h2v-6.2l-2.7-2.6.8-3.6 1.4 1.8H19v-2h-3.6l-2.2-2.8a2.6 2.6 0 0 0-2.6-1.4z" />
    </svg>
  );
}
function TrophyIcon() {
  return (
    <svg className="size-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
      <path d="M8 4h8v5a4 4 0 0 1-8 0zM8 6H4v1a4 4 0 0 0 4 4M16 6h4v1a4 4 0 0 1-4 4M12 13v4m-4 4h8m-6-4h4" strokeLinejoin="round" strokeLinecap="round" />
    </svg>
  );
}
function UserIcon() {
  return (
    <svg className="size-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
      <circle cx="12" cy="8" r="4" />
      <path d="M4 21a8 8 0 0 1 16 0" strokeLinecap="round" />
    </svg>
  );
}
